<template>
  <div class="activityList">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div class="banner">
      <div
        style="width: 1200px; height: 100%; position: relative; margin: 0 auto"
      >
        <div class="upload-btn" style="" @click="toJoin">
          <img src="../../static/server/whiteupload.png" alt="" />
          <span></span>
          专家入驻
        </div>
        <h2>专家库</h2>
        <div class="banner-liner"></div>
        <p>Expert Database</p>
      </div>
    </div>
    <div class="search-wrap">
      <div class="search-input">
        <input type="text" v-model="realName" placeholder="请输入关键字" />
        <button @click="search">搜索</button>
      </div>
      <div class="select-wrap">
        <div class="select-title">行业：</div>
        <div class="select-content">
          <ul>
            <li :class="{active: areaIndex == item.id ? true : false}" @click="areaFn(item.id)" v-for="(item, index) in areaList" :key="index">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul>
      <li
        v-for="(item, index) in expertList"
        :key="index"
        @click="toExpertDetail(item.id)"
      >
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" :src="item.listImg" />
          </div>
          <div class="text">
            <div class="text-b">{{ item.realName }}</div>
            <div class="text-s" v-html="item.remark"><span>{{ item.remark }}</span></div>
          </div>
          <button class="detailBtn" @click="toExpertDetail(item.id)">
            专家详情
          </button>
        </div>
      </li>
    </ul>
    <div style="width: 100%; height: 20px; clear: both"></div>
  </div>
</template>
<script>
import navigation from "@/components/common/navigation";

export default {
  name: "expert",
  components: {
    navigation,
  },
  data() {
    return {
      expertList: [], //专家列表
      areaList: [{}],
      areaIndex: 0,
      realName: ''
    };
  },
  methods: {
    toExpertDetail(id) {
      // this.$router.push('/expertDetail')
      this.$router.push({
        path: "/expertDetail",
        query: {
          id,
        },
      });
    },
    toJoin() {
      this.$axios
        .get("/v1/cloud/user/expert/into/before/msg", {})
        .then(({ data }) => {
          if (data) {
            this.$router.push("/expertJoin");
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    areaFn(id) {
      this.areaIndex = id;
      //专家列表
      this.$axios
        .post("/v1/cloud/common/expert", {
          industryId: id,
        })
        .then(({ data }) => {
          if (data) {
            this.expertList = data;
          }
        });
    },
    search() {
      //专家列表
      this.$axios
        .post("/v1/cloud/common/expert", {
          realName: this.realName,
          industryId: this.areaIndex,
        })
        .then(({ data }) => {
          if (data) {
            this.expertList = data;
          }
        });
    },
  },
  created() {
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.search();
      }
    };

    //专家
    this.$axios.post("/v1/cloud/common/expert", {}).then(({ data }) => {
      if (data) {
        this.expertList = data;
      }
    });

    //行业
    this.$axios.get("/v1/cloud/common/industry").then(({ data }) => {
      if (data) {
        this.areaList = data;
      }
    });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>
<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.activityList {
  // -webkit-touch-callout: none; /* iOS Safari */
  // -webkit-user-select: none; /* Chrome/Safari/Opera */
  // -khtml-user-select: none; /* Konqueror */
  // -moz-user-select: none; /* Firefox */
  // -ms-user-select: none; /* Internet Explorer/Edge */
  // user-select: none;

  width: 100%;
  background-color: #f5f5f5;
  .banner {
    width: 100%;
    height: 500px;
    background: url(../../static/expert/banner.png);
    background-size: 100% 100%;
    background-position: center;
    margin-bottom: 30px;
    position: relative;
    .upload-btn {
      width: 150px;
      height: 50px;
      position: absolute;
      left: 40px;
      top: 50px;
      line-height: 50px;
      border-radius: 20px;
      cursor: pointer;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background-color: #3476c1;
      border-radius: 5px;
      background-image: linear-gradient(#61aafe, #3476c1);
      text-indent: 57px;
      img {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 17px;
        left: 31px;
      }
    }
    h2 {
      font-size: 65px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 60px;
      position: absolute;
      right: 100px;
      top: 100px;
    }
    .banner-liner {
      width: 80px;
      height: 2px;
      background: #ffffff;
      position: absolute;
      top: 191px;
      right: 210px;
    }
    p {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
      position: absolute;
      top: 223px;
      right: 106px;
    }
  }
  .search-wrap {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 30px;
    .search-input {
      margin-left: 61px;
      margin-bottom: 24px;
      input {
        width: 600px;
        outline: none;
        height: 40px;
        vertical-align: middle;
        text-indent: 11px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        border-radius: 3px;
        background-color: #fff;
      }
      input::placeholder {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      button {
        width: 100px;
        height: 40px;
        background: #3476c1;
        border-radius: 0px 3px 3px 0px;
        outline: none;
        border: none;
        text-align: center;
        line-height: 40px;
        margin-left: -1px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .select-wrap {
      display: flex;
      background-color: #fff;
      padding: 30px 16px;
      box-sizing: border-box;
      .select-title {
        width: 43px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #666666;
        line-height: 30px;
      }
      .select-content {
        width: 1100px;
        ul {
          width: 100%;
          margin: 0;
          li {
            cursor: pointer;
            list-style: none;
            display: inline-block;
            width: auto;
            padding: 0 10px;
            line-height: 30px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            margin-right: 20px;
            margin-bottom: 10px;
            span {
                white-space: nowrap;
            }
          }
          li.active {
             background-color: #3476C1;
             color: #fff;
          }
        }
      }
    }
  }
  ul {
    width: 1200px;
    list-style-type: none;
    margin: 30px auto;
    height: auto;
    // overflow: hidden;
    li {
      padding: 20px;
      width: 1200px;
      box-sizing: border-box;
      margin-bottom: 20px;
      background-color: #fff;
      .li-wrap {
        height: 230px;
        width: 100%;
        position: relative;
        cursor: pointer;
        img {
          height: 230px;
          width: 370px;
          float: left;
        }
        .text {
          width: 760px;
          float: left;
          padding: 10px 20px 20px;
          .text-b {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            margin-bottom: 18px;
          }
          .text-s {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            height: 76px;
            overflow: hidden;
          }
          .people {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            margin: 5px 0;
            span {
              color: #0f9bf1;
              font-size: 18px;
              margin-right: 64px;
            }
          }
          .date {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            span {
              color: #333333;
            }
          }
        }
        .detailBtn {
          width: 150px;
          height: 40px;
          border: 1px solid #5fc0e4;
          border-radius: 3px;
          line-height: 40px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5fc0e4;
          outline: none;
          position: absolute;
          right: 30px;
          bottom: 20px;
          background-color: #fff;
        }
        .detailBtn:hover {
          color: #fff;
          background: rgba(0, 0, 0, 1);
        }
      }
    }
    li:hover {
      .li-wrap {
        background-color: #f5f5f5;
        .detailBtn {
          color: #fff;
          background-color: #5fc0e4;
        }
      }
    }
  }
}
</style>